<script lang="ts">
	//Design System Components
	import { Text, Icon } from '@Shelly/shelly-design-system';
	//Types
	import type { IconProps } from '@Shelly/shelly-design-system/Icon/Icon.svelte';
	//Helpers
	import { classMap } from '@Shelly/shelly-design-system/helpers/component-utils';
	import type { ColorVariant } from '../../list-helpers';

	let className = '';
	export { className as class };
	export let icon: IconProps['icon'] = '';
	export let title = '';
	export let counter = 0;
	export let color: ColorVariant = 'muted';

	const colorMapper = {
		success: 'text-success',
		warning: 'text-warning',
		danger: 'text-danger',
		muted: 'text-color-muted',
	};
</script>

<div class={classMap({ 'd-flex align-items-center': true, [className]: true })}>
	{#if icon}
		<Icon class="mr-s" icon={`${icon} ${colorMapper[color]}`} size="s" />
	{/if}
	{#if counter !== undefined}
		<Text class={`mr-xs text-bold ${colorMapper[color]}`} styleType="body-small">
			{counter}
		</Text>
	{/if}
	{#if title}
		<Text styleType="body-small">
			{title}
		</Text>
	{/if}
</div>
